module.exports = __webpack_public_path__ + "media/two_yellow.9b30758a.mp3";